import type { LocalizedDict } from '../index'

// Start-a-Company wizard progress stepper (features/start-company/ui.tsx).
// Kept separate from the form dictionary so the public bundle stays small.
export type WizardStepperStrings = {
  progress: string
}

export const wizardStepperI18n: LocalizedDict<WizardStepperStrings> = {
  en: {
    progress: 'Progress',
  },
  tr: {
    progress: 'İlerleme',
  },
}
